<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Complete-Approval',
};
</script>

<style>

</style>
